var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 8.45143V9.00343C13.9993 10.2973 13.5803 11.5562 12.8056 12.5925C12.0309 13.6288 10.942 14.3869 9.70121 14.7538C8.46046 15.1206 7.13435 15.0766 5.92068 14.6282C4.70701 14.1798 3.67079 13.3511 2.96658 12.2657C2.26236 11.1803 1.92787 9.89627 2.01301 8.60522C2.09814 7.31417 2.59832 6.08523 3.43897 5.10168C4.27961 4.11813 5.41567 3.43266 6.67771 3.14752C7.93975 2.86238 9.26016 2.99284 10.442 3.51943","stroke":"#595959","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14 4.33333L7.84615 10.3333L6 8.53513","stroke":"#595959","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircle.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
